// extracted by mini-css-extract-plugin
module.exports = {"bg":"Loading_bg__2Odh5","logo":"Loading_logo__KWhrX","load":"Loading_load__1vdii","text":"Loading_text__1eQAX"};